import { modalActions } from "@context/modals";
import Button from "@shared/components/button/Button";
import { IconButton } from "@shared/components/icon-button";
import { BUTTON_SIZE, BUTTON_VARIANT } from "@shared/components/button/types";
import { ICON_COLOR, ICON_SIZE } from "@shared/components/icon-button/types";
import BadgeCheck from "@svg/badge-check";
import { IconChevronDown } from "@svg/chevron-down";
import WarrantyIcon from "@svg/warranty-icon";
import { FC } from "react";
import { MODAL_TYPES } from "types/modals";

export const courseQualityWarrantySrc =
  "https://faradars.org/wp-content/uploads/2025/05/19/layer_88.svg";

const Warranty: FC = () => {
  const handleOpenDetailsModal = () => {
    modalActions.addModal(MODAL_TYPES.COURSE_WARRANTY_DETAILS, {
      config: {
        modalHeaderClassName: "hidden",
        modalClassName:
          "h-[100dvh] max-h-none xsm:max-h-[calc(100dvh-64px)] xsm:h-fit overflow-y-auto overflow-x-hidden",
        modalContentClassName:
          "h-[100dvh] max-h-none xsm:h-fit overflow-y-auto overflow-y-auto overflow-x-hidden",
      },
    });
  };

  return (
    <div className="py-6  md:py-8">
      <div className="rounded-12 border relative border-fds-divider flex sm:gap-4     items-center overflow-hidden">
        <div className="px-3  py-4     md:p-6  w-full md:grom">
          <div className="w-full flex gap-2 justify-between items-center mb-2.5">
            <strong className="headline-sm md:headline-md flex items-start gap-2">
              <WarrantyIcon className="w-6 h-6 basis-6 grow-0 shrink-0 md:hidden" />
              تضمین کیفیت
            </strong>
            <IconButton
              className="rotate-90 md:hidden"
              iconClassName="text-fds-brand"
              icon={<IconChevronDown />}
              size={ICON_SIZE.MEDIUM}
              color={ICON_COLOR.BRAND}
              onClick={handleOpenDetailsModal}
              aria-label="باز و بسته کردن محتوا"
            />
          </div>
          <p className="text-fds-secondary body-sm md:body-md font-normal mb-3 max-w-[478px]">
            کیفیت این آموزش توسط فرادرس تضمین شده است. در صورت عدم رضایت از
            آموزش به انتخاب شما:
          </p>
          <div className="mt-3  mb-2">
            <div className="flex items-center gap-1">
              <BadgeCheck className="ml-1 text-fds-icon-accent" />
              <p className="text-fds-primary title-sm md:title-md-medium">
                ۱۰۰ ‌درصد مبلغ پرداختی در حساب کاربری شما شارژ می‌شود.
              </p>
            </div>
            <div className="flex items-center gap-1 mt-1">
              <BadgeCheck className="ml-1 text-fds-icon-accent" />
              <p className="text-fds-primary title-sm md:title-md-medium">
                ۷۰ ‌درصد مبلغ پرداختی به حساب بانکی شما بازگشت داده می‌شود.
              </p>
            </div>
          </div>
          <div className="w-full justify-start hidden md:flex">
            <Button
              endIcon={<IconChevronDown className="mr-2 w-4 h-4 rotate-90" />}
              size={BUTTON_SIZE.LARGE}
              variant={BUTTON_VARIANT.TEXT_ACTION}
              className="text-fds-brand"
              onClick={handleOpenDetailsModal}
            >
              اطلاعات بیشتر
            </Button>
          </div>
        </div>
        <div className="hidden md:flex justify-center px-8   h-full items-center ml-6">
          <img
            src={courseQualityWarrantySrc}
            alt="Warranty"
            className="h-[196px]"
          />
        </div>
      </div>
    </div>
  );
};

export default Warranty;
